import React from 'react';

import { ThemeProvider, Button, Typography, Grid } from '@mui/material';
import './App.css'; // This defines the styles. See MyReactComponent.js for more info
import './BrandDesign.css'; //contains classes with Siemens colors for buttons and other interactive elements
import darkTheme from './theme';
import InteractiveVideo from './Components/interactive-video/index';
import DragToImage from './Components/DragToImage/index';
import { ChoiceExercise } from 'didactic-choice-exercise';


const App = () => {


    const onFinish = () => {
        return;
    }

    const Exercise1 = ({ onFinish }) => {

        const basicStyle = {
            cardRoot: {
                backgroundColor: '#333333'
            },
            optionSelected: {
                background: 'gray',
                color: 'white'
            },
            option: {
                width: '100%',
                fontSize: '18px',
                fontWeight: 500,
                textTransform: 'initial',
                padding: '7px 21px',
                border: '1px solid rgba(255, 255, 255, 0.23)',
                boxSizing: 'border-box',
                transition: 'background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
                borderRadius: '4px',
                cursor: 'pointer',
                color: '#fff'
            },
            selected: {
                background: 'gray',
                color: 'white'
            },
            correct: {
                background: 'green',
                color: 'white'
            },
            incorrect: {
                background: 'red',
                color: 'white'
            },
            button: {
                color: '#fff',
                margin: "10px"
            },
            question: {
                color: '#fff',
                marginBottom: '20px'
            },
            feedback: {
                color: '#fff',
                marginTop: '20px'
            }

        };
        const nextBtn = (<Button style={{fontSize: '18px !important'}} className="bdo-button">Weiter</Button>);

        const questions =
            [
                {
                    question: <div>
                        <Typography paragraph={true}><i>Lesen Sie sich die Beschreibung von Frau Müllers Daten durch und entscheiden Sie darauf basierend, welchen Beruf sie ausübt.</i></Typography>
                        <Grid container spacing={3} alignItems="center"><Grid item xs={4}>
                            <img src="img/1-3-2a.jpg" width="100%" alt="" />
                        </Grid>
                            <Grid item xs={8}><Typography paragraph>Frau Müller kauft sich jeden Morgen um 8:30 Uhr einen doppelten Soja-Macchiato mit Pistazie im Coffee-Shop. Sie legt laut GPS-Tracking während der Arbeitszeit täglich ca. 4-5km zurück. Sie hat einen durchschnittlichen Puls von 100 Schlägen pro Minute, wie ihr ihr Fitnessarmband verrät.</Typography>
                            </Grid>
                        </Grid>
                        <Typography paragraph textAlign="center">Frau Müller ist...</Typography>
                    </div>,
                    isSingleChoice: true,
                    options: [
                        {
                            value: <Button>Bankkauffrau</Button>,
                            feedback: <Typography paragraph={true}></Typography>,
                            id: "q11",
                            isCorrect: false
                        },
                        {
                            value: <Button>Bäckerin</Button>,
                            feedback: <Typography paragraph={true}></Typography>,
                            id: "q12",
                            isCorrect: true
                        },
                        {
                            value: <Button>Angestellte im Supermarkt</Button>,
                            feedback: <Typography paragraph={true}></Typography>,
                            id: "q13",
                            isCorrect: false
                        },
                        {
                            value: <Button>DJ</Button>,
                            feedback: <Typography paragraph={true}></Typography>,
                            id: "q14",
                            isCorrect: false
                        }
                    ]
                }
            ]

        const onFinishCE1 = () => {
            onFinish();
        }

        return (
            <div className='light-text'>
                <ChoiceExercise
                    exerciseQuestions={questions}
                    multipleAttempts={false}
                    isRetry={false}
                    showInstantFeedback={true}
                    isNext={true}
                    rowWiseOptions={false}
                    basicStyle={basicStyle}
                    nextBtn={nextBtn}
                    onFinish={onFinishCE1}
                /></div>
        )

    }

    const Exercise2 = ({ onFinish }) => {


        const dragList = [
            {
                id: "main:1",
                options: {
                    "1": <Typography component="div">Ruhepuls: Ø 82 Schläge/ Minute<br />
                    Zeit online: Ø 0,2h/ Tag<br />
                    Zeit auf sozialen Netzwerken: Ø 0h/ Tag<br />
                    Letzte 3 Eingaben in Suchmaschinen:<br />
                    <ul><li>Hortensienschädlinge</li>
                    <li>Hundefrisör</li>
                    <li>Alsterfest</li></ul>
                    Nachrichten über Messengerdienste: Ø 0,3 /Tag</Typography>,
                    "2": <Typography component="div">Ruhepuls: Ø 65 Schläge/ Minute<br />
                    Zeit online: Ø 5,1h/ Tag<br />
                    Zeit auf sozialen Netzwerken: Ø 4,3h/ Tag<br />
                    Letzte 3 Eingaben in Suchmaschinen:<br />
                    <ul><li>Preis Balkonmarkise</li>
                    <li>Wetter</li>
                    <li>Bundespräsidialamt</li></ul>
                    Nachrichten über Messengerdienste: Ø 98 /Tag</Typography>,
                    "3": <Typography component="div">Ruhepuls: Ø 83 Schläge/ Minute<br />
                    Zeit online: Ø 6,0h/ Tag<br />
                    Zeit auf sozialen Netzwerken: Ø 1,5h/ Tag<br />
                    Letzte 3 Eingaben in Suchmaschinen:<br />
                    <ul><li>Boss besiegen beste Technik</li>
                    <li>Welche Pollen sind allergisch</li>
                    <li>Flechtfrisur</li></ul>
                    Nachrichten über Messengerdienste: Ø 32,9 /Tag</Typography>,
                    "4": <Typography component="div">Ruhepuls: Ø 45 Schläge/ Minute<br />
                    Zeit online: Ø 6,7h/ Tag<br />
                    Zeit auf sozialen Netzwerken: Ø 0,6h/ Tag<br />
                    Letzte 3 Eingaben in Suchmaschinen:<br />
                    <ul><li>Was ist Kombucha</li>
                    <li>Beste Spiele des Jahres</li>
                    <li>Zitierhilfe</li></ul>
                    Nachrichten über Messengerdienste: Ø 6,0 /Tag</Typography>
                },
                cards: [
                     {
                    answer: "3",
                    src: "img/1-3-2b1.jpg",
                    heading: <Typography sx={{p: '5px', pl: '20px'}}>Anna B.<br />Schülerin, 14<br />Stuttgart</Typography>,
                },
                {
                    answer: "2",
                    src: "img/1-3-2b2.jpg",
                    heading: <Typography sx={{p: '5px', pl: '20px'}}>Maria R.<br />Vermieterin von Ferienwohnungen, 50<br />Berlin</Typography>,
                },
                {
                    answer: "4",
                    src: "img/1-3-2b3.jpg",
                    heading: <Typography sx={{p: '5px', pl: '20px'}}>Dima F.<br />Sportstudent, 23<br />Frankfurt</Typography>
                },
                {
                    answer: "1",
                    src: "img/1-3-2b4.jpg",
                    heading: <Typography sx={{p: '5px', pl: '20px'}}>Herbert K.<br />Rentner, 76<br />Hamburg</Typography>
                },
            ]
            },
        ]


        const finishEx2 = (result) => {
            onFinish();
        }

        return (
            <div className='light-text'>
                <DragToImage
                    id={dragList[0].id}
                    cardList={dragList[0].cards}
                    textList={dragList[0].options}
                    onFinish={finishEx2}
                /></div>
        )
    }

    const markers = [{
        name: "0 - startMarker",
        markerStart: 0,
        pause: false
    },
    {
        name: "1 - Choice Exercise 1",
        markerStart: 87,
        pause: true,
        component: <Exercise1 onFinish={onFinish} />
    },
    {
        name: "2 - Drag and Drop Exercise",
        markerStart: 117,
        pause: true,
        component: <Exercise2 onFinish={onFinish} />
    },
    ];


    return (
        <ThemeProvider theme={darkTheme}>
            <InteractiveVideo markers={markers} videoSrc="1-3-2_COMP.mp4" muiTheme={darkTheme} number={0} />
        </ThemeProvider>
    )
}

export default App;